import { useUserStore } from "@/store";
import { DirectiveBinding } from "@vue/runtime-core";

/**
 * @name v-access カスタムディレクティブ
 * @description 画面要素をユーザーroleに基づいて表示するか判断
 * @example <button v-access="['ULT1','ULT2']"> ボタン </button>  //承認者一般と承認者管理のみに表示する
 */
function checkPermission(el: any, binding: DirectiveBinding<any>) {
  const { value } = binding;
  const userStore = useUserStore();
  const role = userStore.getRole;

  if (value && value instanceof Array) {
    if (value.length > 0) {
      const accessRoles = value;

      const hasAccessPermission = accessRoles.includes(role);

      if (!hasAccessPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  } else {
    throw new Error(
      `アクセスできるroleの設定は必要です。例： v-access="['ULT1','ULT2']"`
    );
  }
}

export default {
  mounted(el: any, binding: DirectiveBinding<any>) {
    checkPermission(el, binding);
  },
  updated(el: any, binding: DirectiveBinding<any>) {
    checkPermission(el, binding);
  },
};
